// extracted by mini-css-extract-plugin
export default {"divv":"lapUI_divv__4xhrX","icons":"lapUI_icons__g6JE4","links":"lapUI_links__XYHV1"};